var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStats = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 13",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.333 8.333H1V11h1.333V8.333ZM1 7.333a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h1.333a1 1 0 0 0 1-1V8.333a1 1 0 0 0-1-1H1ZM6.667 7H5.333v4h1.334V7ZM5.333 6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.334a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5.333ZM11 5.667H9.667V11H11V5.667Zm-1.333-1a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V5.667a1 1 0 0 0-1-1H9.667ZM11.724.188a.5.5 0 0 1-.078.702L6.937 4.657a1.5 1.5 0 0 1-1.874 0l-.75-.6a.5.5 0 0 0-.625 0L.979 6.224a.5.5 0 0 1-.625-.781l2.709-2.167a1.5 1.5 0 0 1 1.874 0l.75.6a.5.5 0 0 0 .625 0L11.021.11a.5.5 0 0 1 .703.078Z",
    fill: "#9999AC"
  })));
};
export default SvgStats;